module.exports = __webpack_public_path__ + "sprstatic/img/weixin.505b1f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/weixin.jpg
// module id = Jsay
// module chunks = 2